import { useEffect } from "react";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "primereact/card";
import SafeHtml from "../../../../components/safe-html";
import FaleConoscoController from "../controller/fale-conosco.controller";
import { isValidPortalUrl } from "../types/fale-conosco.types";

export default function FaleConosco() {
  const controller = new FaleConoscoController();

  useEffect(() => {
    controller.init();
  }, []);

  const registro = controller.registro;
  const linkPortal = registro?.dsLinkSuporte ?? "";
  const linkDisponivel = isValidPortalUrl(linkPortal);

  return (
    <div className="fale-conosco">
      <Card>
        <h3 className="fale-conosco__page-title">Fale conosco</h3>

        {controller.consultaConcluida && !registro && (
          <div className="fale-conosco__empty">
            Nenhum conteúdo de Fale conosco foi encontrado.
          </div>
        )}

        {registro && (
          <div className="fale-conosco__content">
            <div className="fale-conosco__message">
              <SafeHtml html={registro.dsSuporte} />
            </div>

            <div className="fale-conosco__portal">
              {linkDisponivel ? (
                <a
                  className="fale-conosco__portal-button p-button p-component"
                  href={linkPortal}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faLink} />
                  <span>Acessar Fale conosco no Portal ANTT</span>
                </a>
              ) : (
                <button
                  type="button"
                  className="fale-conosco__portal-button fale-conosco__portal-button--disabled p-button p-component p-disabled"
                  disabled
                >
                  <FontAwesomeIcon icon={faLink} />
                  <span>Link do portal indisponível</span>
                </button>
              )}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
